import {useAppSelector} from 'store/hooks';
import type {ManifestationV4} from '../types';
import {selectMetadataEditSavedMetadataSelector} from '../metadataEditSlice';

/**
 * Use unique manifestation, either by given id
 * or single manifestation on work
 */
export const useUniqueSavedManifestation = (
  manifestationId: string | undefined,
): ManifestationV4 | undefined => {
  const metadata = useAppSelector(selectMetadataEditSavedMetadataSelector);
  const manifestations = metadata?.manifestations ?? [];
  const manifestation = manifestationId
    ? manifestations.find(m => m.id === manifestationId)
    : manifestations.length === 1
      ? manifestations[0]
      : undefined;

  return manifestation;
};
